export const buildMappings = (values, fieldList, valueSet) => {
  _.map(values, value => {
    fieldList.push({ label: value.label, value: value.name })
    valueSet[value.name] = {
      valueType: value.type,
      fieldLabel: value.label,
      picklistValues: _.map(value.picklistValues, picklistValue => ({
        label: picklistValue.label,
        value: picklistValue.value,
      })),
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/assistantSettings/helpers.js